import createReducer from "Common/reducerUtils/createReducer";
import isUndefined from "lodash/isUndefined";
import size from "lodash/size";
import { NAMESPACE, NEW_DOCUMENT } from "../constants";
import modeEnum from "../mode";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: { draft: {}, data: undefined, documentId: undefined, mode: undefined }
};
export default createReducer(initialState, {
    [actionTypes.SET_DRAFT]: (state, { draft }) => {
        const isDraftPartial = size(draft) === 1;
        return {
            ...state,
            [NAMESPACE]: {
                ...state[NAMESPACE],
                draft: isDraftPartial && draft ? { ...state[NAMESPACE].draft, ...draft } : draft
            }
        };
    },
    [actionTypes.GET_DOCUMENT_COMPLETED]: (state, { payload }) => state[NAMESPACE].documentId === payload.Id
        ? {
            ...state,
            [NAMESPACE]: {
                ...state[NAMESPACE],
                data: payload
            }
        }
        : state,
    [actionTypes.SET_MODE_AND_DOCUMENT_ID]: (state, { documentId, projectId, mode }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            documentId: mode === modeEnum.CREATE ? NEW_DOCUMENT.Id : documentId,
            mode,
            data: mode === modeEnum.CREATE ? { ...NEW_DOCUMENT, ProjectId: projectId } : undefined,
            draft: isUndefined(mode) ? state[NAMESPACE].draft : {}
        }
    })
});
